const Cookie = {

    get(name) {
        return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';
    },

    set(name, value, expires) {
        document.cookie = name+"="+value+"; expires="+expires+"; Path=/";
    },

    remove(name) {
        document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
}

export default Cookie;